import { i18n } from '@/commons/utils';

export function PaypalToken(slider) {

  this.init = function init(params) {
    this.container = params.container;
    this.index = params.index;
    this.isNewAccount = params.isNewAccount;
    this.isFavorite = (this.container.getAttribute('data-is-favorite') === 'true');
    this.tokenId = this.container.querySelector('.dkt-card').getAttribute('data-token-id');
    this.isWallet = params.isWallet || false;
    this.slider = slider;
    this.state = {
      isSelected: params.isSelected,
      isCvcTooltipVisible: false
    };
    if (this.isWallet === false) {
      this.container.classNameToggle('dkt-card-slider-item--selected', this.state.isSelected);
    }
    this.events();
  };
}

PaypalToken.prototype.events = function events() {
  if (this.isWallet === false) {
    this.container.addEventListener('click', this.select.bind(this));
  }
  document.addEventListener('unSelectAllPaypalCards', this.unselect.bind(this));
  this.walletEvents();
};

PaypalToken.prototype.walletEvents = function walletEvents() {
  if (this.isWallet === true) {
    if (this.container.querySelector('.dkt-gift-card-menu-item--favorite') !== null) {
      this.container.querySelector('.dkt-gift-card-menu-item--favorite').addEventListener('click', this.setAsFavorite.bind(this));
    }
    if (this.container.querySelector('.dkt-gift-card-menu-item--delete') !== null) {
      this.container.querySelector('.dkt-gift-card-menu-item--delete').addEventListener('click', this.removeConfirmation.bind(this));
    }
  } else {
    this.container.addEventListener('click', this.select.bind(this));
  }
};

PaypalToken.prototype.select = function select(event) {
  if ((this.state.isSelected === false && event) || !event) {
    this.slider.displayCard(this);
    document.dispatchEvent(new CustomEvent('unSelectAllPaypalCards'));
    if (this.isWallet === true) {
      this.container.setAttribute('data-is-favorite', 'true');
      this.container.classList.add('dkt-card-slider-item--favorite');
      this.state.isFavorite = true;
    } else {
      this.container.classList.add('dkt-card-slider-item--selected');
    }
    this.state.isSelected = true;
    if (this.isNewAccount === true) {
      if (this.slider.numberOfVisiblesItems > 1) {
        this.slider.moveSlider();
        if (this.slider.numberOfItems > 1) {
          this.slider.navigation.classList.remove('dkt-card-slider-navigation--hidden');
        }
      }
      this.slider.container.classList.add('dkt-card-slider-container--new');
    } else {
      this.slider.container.classList.remove('dkt-card-slider-container--new');
    }
  }
};

PaypalToken.prototype.unselect = function unselect() {
  if (this.isWallet === true) {
    this.container.classList.remove('dkt-card-slider-item--favorite');
    this.container.setAttribute('data-is-favorite', 'false');
    this.state.isFavorite = false;
  } else {
    this.container.classList.remove('dkt-card-slider-item--selected');
  }
  this.state.isSelected = false;
};

PaypalToken.prototype.removeConfirmation = function removeConfirmation() {
  const popin = document.createElement('div');
  popin.className = 'dkt-card-popin';
  popin.innerHTML = `<span class="dkt-card-popin-title">${i18n('myaccount.myMeanOfPayment.deleteConfirmation')}</span>
    <div class="dkt-card-popin-buttons">
      <button class="dkt-card-popin-cancel">${i18n('myaccount.myMeanOfPayment.no')}</button>
      <button class="dkt-card-popin-validate">${i18n('myaccount.myMeanOfPayment.yes')}</button>
    </div>`;
  this.container.appendChild(popin);
  popin.querySelector('.dkt-card-popin-cancel').addEventListener('click', () => {
    popin.parentNode.removeChild(popin);
  });
  popin.querySelector('.dkt-card-popin-validate').addEventListener('click', this.removeCard.bind(this));
};

PaypalToken.prototype.removeCard = function removeCard() {
  const params = {
    tokenId: this.tokenId
  };
  const service = 'rest/model/com/decathlon/cube/commerce/payment/WalletActor/removeToken';
  this.container.classList.add('dkt-card-slider-item--deleted');
  cube.ajax.post(service, params)
    .onError(() => {
      cube.alert.error(i18n('error.oc.call'));
    })
    .call();
};

PaypalToken.prototype.setAsFavorite = function setAsFavorite() {
  const params = {
    tokenId: this.tokenId
  };
  const service = 'rest/model/com/decathlon/cube/commerce/payment/WalletActor/updateFavoriteToken';
  cube.ajax.post(service, params)
    .onSuccess(() => {
      this.select();
    })
    .onError(() => {
      cube.alert.error(i18n('error.oc.call'));
    })
    .call();
};



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-paypal-token.js